import {Module, VuexModule, Mutation, Action, getModule, MutationAction} from 'vuex-module-decorators';
import store from '@/model/store/store';
import lgcApi from '@/model/api';
import {GCICategoryInfoRes, GCICategoryListRes, GCICategoryManageListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUCATDataReq, PostUpsertCategoryReq} from '@/model/dto/req/category/post-upsert-category-req';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import {PDCDataReq, PostDeleteContentsReq} from '@/model/dto/req/contents/post-delete-contents-req';
import {PUHDataReq, PostUpsertHeadlineReq} from '@/model/dto/req/headline/post-upsert-headline-req';
import {PUADataReq, PostUpsertAboutReq} from '@/model/dto/req/about/post-upsert-about-req';
import {PUMDataReq, PostUpsertMenuReq} from '@/model/dto/req/menu/post-upsert-menu-req';
import {PUIDataReq, PostUpsertInfomationReq} from '@/model/dto/req/infomation/post-upsert-infomation-req';
import {PLDataReq, PostLoginReq} from '@/model/dto/req/login/post-login-req';
import {GLIUserRes, GetLoginInfoRes} from '@/model/dto/res/login/get-login-info-res';
import {GCIHeaderRes, GCIHeaderInfoRes} from '@/model/dto/res/header/get-header-info-res';
import {PUIHDataReq, PostUpsertHeaderReq} from '@/model/dto/req/header/post-upsert-header-req';
import {PUUDataReq, PostUpsertUserReq} from '@/model/dto/req/user/post-upsert-user-req';
import {SearchQueryInterface} from '@/model/interfaces/search-interface';
import {DialogBeforePostInterface} from '@/model/interfaces/content-interface';
import {UserDataOnSessionStorageDataInterface, UserDataOnSessionStorageInterface} from '@/model/interfaces/user-interface';
import logo from '@/assets/logo.png';
import _ from 'lodash';

@Module({dynamic: true, store, namespaced: true, name: 'appModule'})
class AppModule extends VuexModule {
  // States
  private strageData: UserDataOnSessionStorageInterface = JSON.parse(sessionStorage.getItem('undeux') || '{}');

  public isLoading: boolean = false; // ローディングフラグ
  public isConfirmationDialog: DialogBeforePostInterface<any> = {state: false, title: '', message: '', data: null}; // 確認ダイアログデータ
  public isHeaderImageDialog: DialogBeforePostInterface<any> = {state: false, title: '', message: '', data: null}; // ヘッダー画像ダイアログデータ
  public isAboutEditDialog: DialogBeforePostInterface<any> = {state: false, title: '', message: '', data: null}; // 確認ダイアログデータ
  public isError: { state: boolean, title?: string, message?: string, status?: number }  = {state: false}; // エラーフラグ
  public token: string = JSON.stringify(this.strageData) !== '{}' ? this.strageData.appModule.token : ''; // 認証トークン(JWT)
  public loginData: GLIUserRes = {};
  public menuInfo: {
    logoIcon: string; // ロゴアイコン
    homeLink: string; // Home Link
  } = {
    logoIcon: logo,
    homeLink: '/'
  };
  public searchKeyword: string = ''; // 検索キーワード

  public categoryInfo: GCICategoryListRes[] = [];
  public categorySelectInfo: GCICategoryListRes[] = [];
  public categoryManageInfo: GCICategoryManageListRes[] = [];
  public isCategoryManage: Array<{
    state: boolean,
    idx: number
  }> = [];
  public isValid: boolean = true;
  public inputIndex: number = 0;
  public meta: AppModule.MetaInterface = {};

  // Mutations
  @Mutation
  private setMeta(meta: AppModule.MetaInterface) {
    this.meta = meta;
  }

  @Mutation
  private setIsLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }

  @Mutation
  private setIsValid(state: boolean): void {
    this.isValid = state;
  }

  @Mutation
  private setIsConfirmationDialog(param: DialogBeforePostInterface<PUCDataReq|PUCATDataReq[]|PUADataReq|PUHDataReq|PUMDataReq|PUIDataReq|PUUDataReq>): void {
    this.isConfirmationDialog = param;
  }

  @Mutation
  private setIsAboutEditDialog(param: DialogBeforePostInterface<PUCDataReq|PUCATDataReq[]>): void {
    this.isAboutEditDialog = param;
  }

  @Mutation
  private setIsDeleteConfirmationDialog(param: DialogBeforePostInterface<PDCDataReq>): void {
    this.isConfirmationDialog = param;
  }

  @Mutation
  private setInitIsCategoryManage(
    param: Array<{
      state: boolean,
      idx: number
    }>
  ): void {
    this.isCategoryManage = param;
  }

  @Mutation
  private setIsCategoryManage(
    param: {
      state: boolean,
      idx: number
    }
  ): void {
    this.isCategoryManage[param.idx].state = param.state;
    this.isCategoryManage[param.idx].idx = param.idx;
  }

  @Mutation
  private setIsHeaderImageDialog(param: DialogBeforePostInterface<PUCDataReq|PUIHDataReq>): void {
    this.isHeaderImageDialog = param;
  }

  @Mutation
  private setIsError(param: {state: boolean, title?: string, message?: string, status?: number}): void {
    this.isError = param;
  }

  @Mutation
  private setToken(token: string): void {
    // localStorage.setItem('token', token); // ローカルストレージにtokenを保存する。
    this.token = token;
  }

  @Mutation
  private setSearchKeyword(str: string): void {
    this.searchKeyword = str;
  }

  @Mutation
  private setCategoryList(
    param: {
      category_id: number,
      published: number,
      approval: number,
      owned: number
    }
  ) {
    _.each(this.categoryInfo, (key: GCICategoryListRes) => {
      if (key.category_id === param.category_id) {
        key.published = param.published;
        key.approval = param.approval;
        key.owned = param.owned;
      }
    });
  }

  @Mutation
  private setCategoryManageInfo(
    param: GCICategoryManageListRes[]
  ) {
    const manageInfo: GCICategoryManageListRes[] = _.map(param, (c: GCICategoryManageListRes, idx: number) => {
      c.category_order = idx + 1;
      return c;
    });
    this.categoryManageInfo = manageInfo;
  }

  @Mutation
  private setAddCategoryManageInfo(
    param: GCICategoryManageListRes
  ) {
    this.categoryManageInfo.push(param);
    this.isCategoryManage.push({state: false, idx: param.category_id + 1});
  }

  @Mutation
  private setCategoryManageName(
    param: {
      val: string,
      idx: number
    }
  ) {
    this.categoryManageInfo[param.idx].category_name = param.val;
  }

  @Mutation
  private setCategoryManageType(
    param: {
      val: string,
      idx: number
    }
  ) {
    this.categoryManageInfo[param.idx].category_type = param.val;
  }

  @Mutation
  private setCategoryManageDelete(
    param: {
      state: boolean,
      idx: number
    }
  ) {
    this.categoryManageInfo[param.idx].deleted = param.state;
  }

  @Mutation
  private setInputIndex(
    idx: number
  ) {
    this.inputIndex = idx;
  }

  // Actions
  @Action
  public updateMeta(
    meta: AppModule.MetaInterface
  ) {
    this.setMeta(meta);
  }

  /**
   * アプリケーション全体で用いる共通情報の初期化
   *
   * @param param
   */
  @Action
  public initApp(
    param: {
      token: string
    }
  ): void {
    this.setToken(param.token);
  }

  /**
   * 認証用トークンのアップデート
   *
   * @param param
   */
  @Action
  public updateToken(
    param: {
      token: string
    }
  ) {
    this.setToken(param.token);
  }

  @Action
  public updateCategoryList(
    param: {
      category_id: number,
      published: number,
      approval: number,
      owned: number
    }
  ) {
    this.setCategoryList(param);
  }

  /**
   * 検索キーワードのアップデート
   *
   * @param param
   */
  @Action
  public updateSearchKeyword(str: string) {
    this.setSearchKeyword(str);
  }

  /**
   * ローディングスタート
   */
  @Action
  public startLoading(): void {
    this.setIsLoading(true);
  }

  /**
   * ローディングストップ
   */
  @Action
  public stopLoading(): void {
    this.setIsLoading(false);
  }

  @Action
  public updateIsValid(state: boolean): void {
    this.setIsValid(state);
  }

  /**
   * 確認用ダイアログを表示・非表示
   */
  @Action
  public updateIsConfirmationDialog(param: DialogBeforePostInterface<PUCDataReq|PUCATDataReq[]|PUADataReq|PUHDataReq|PUMDataReq|PUIDataReq|PUUDataReq>): void {
    this.setIsConfirmationDialog(param);
  }

  /**
   * 削除確認用ダイアログを表示・非表示
   */
  @Action
  public updateIsDeleteConfirmationDialog(param: DialogBeforePostInterface<PDCDataReq>): void {
    this.setIsDeleteConfirmationDialog(param);
  }

  /**
   * ヘッダー画像用ダイアログを表示・非表示
   */
  @Action
  public updateIsHeaderImageDialog(param: DialogBeforePostInterface<PUCDataReq|PUIHDataReq>): void {
    this.setIsHeaderImageDialog(param);
  }

  /**
   * about用ダイアログを表示・非表示
   */
  @Action
  public updateIsAboutEditDialog(param: DialogBeforePostInterface<PUCDataReq|PUCATDataReq[]>): void {
    this.setIsAboutEditDialog(param);
  }

  @Action
  public updateInitIsCategoryManage(
    param: Array<{
      state: boolean,
      idx: number
    }>
  ): void {
    this.setInitIsCategoryManage(param);
  }

  @Action
  public updateIsCategoryManage(
    param: {
      state: boolean,
      idx: number
    }
  ): void {
    this.setIsCategoryManage(param);
  }

  /**
   * apiエラー用ダイアログを表示・非表示
   */
  @Action
  public updateIsError(param: {state: boolean, title?: string, message?: string, status?: number}): void {
    this.setIsError(param);
  }

  @Action
  public updateCategoryManageInfo(
    param: GCICategoryManageListRes[]
  ) {
    this.setCategoryManageInfo(param);
  }

  @Action
  public updateAddCategoryManageInfo(
    param: GCICategoryManageListRes
  ) {
    this.setAddCategoryManageInfo(param);
  }

  @Action
  public updateCategoryManageName(
    param: {
      val: string,
      idx: number
    }
  ) {
    this.setCategoryManageName(param);
  }

  @Action
  public updateCategoryManageType(
    param: {
      val: string,
      idx: number
    }
  ) {
    this.setCategoryManageType(param);
  }

  @Action
  public updateCategoryManageDelete(
    param: {
      state: boolean,
      idx: number
    }
  ) {
    this.setCategoryManageDelete(param);
  }

  @Action
  public updateInputIndex(
    idx: number
  ) {
    this.setInputIndex(idx);
  }

  /**
   * ログインをリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestLoginInfo(
    param: PLDataReq
  ): Promise<any> {
    try {
      const res = await lgcApi.postLoginInfo(param);
      return {
        loginData: res.results,
        token: res.results.token
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * ログインをリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestLogoutInfo(): Promise<any> {
    try {
      const res = await lgcApi.postLogoutInfo();
      return {
        loginData: res.results
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * カテゴリ情報をリクエスト
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestCategoryInfo(param: SearchQueryInterface): Promise<any> {
    try {
      console.log(param);
      const info = await lgcApi.getCategoryInfo(param);
      return {
        categoryInfo: info.result
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * カテゴリ情報(タイプに応じた)をリクエスト
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestCategorySelectInfo(categoryType?: string): Promise<any> {
    try {
      const info = await lgcApi.getCategorySelectInfo(categoryType);
      return {
        categorySelectInfo: info.result
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * カテゴリ情報をリクエスト（カテゴリ管理用）
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestCategoryManageInfo(param: SearchQueryInterface): Promise<any> {
    try {
      const info = await lgcApi.getCategoryManageInfo(param);
      return {
        categoryManageInfo: info.result
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * カテゴリ情報更新をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUpsertCategoryInfo(
    param: PUCATDataReq[]
  ): Promise<any> {
    try {
      const info = await lgcApi.postUpsertCategoryInfo(param);
      return {
        categoryManageInfo: info.result
      };
    } catch (err) {
      throw err;
    }
  }

}

namespace AppModule {
  export interface MetaInterface {
    title?: string;
    description?: string;
    type?: string;
    url?: string;
    updated_time?: string;
    image?: string;
  }
}

export default getModule(AppModule);
